var exports = {
  "kL": "x0a7806d5--e81a47--container",
  "vW": "x0a7806d5--e81a47--inner",
  "DD": "x0a7806d5--e81a47--title",
  "h_": "x0a7806d5--e81a47--description",
};

module.exports = exports;
